import React from 'react';
import Image from 'next/image';

import styles from './ChatBox.module.css';

export default class ChatBox extends React.Component {
  componentDidMount() {
    const { addNewChat, id, delay, limit } = this.props;
    this.timeout = setTimeout(() => {
      if (id < limit) {
        addNewChat(id);
      } else {
        clearTimeout(this.timeout);
      }
    }, delay);
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  render() {
    const { delay, id, textSizes } = this.props;
    return (
      <div className="flex justify-start mb-6">
        <div className={`${styles.avatar} w-12 h-12 mr-2 flex-shrink-0 rounded-lg`}>
          <Image
            layout="fill"
            src={`/static/images/sections/enterprise-ready/slack-avatar-${id % 2}.png`}
            alt={`chat avatar ${id % 2}`}
          />
        </div>
        <div className="flex-grow-1">
          <div
            className={`${styles.text} bg-gray-200 h-4 mb-2 rounded-full`}
            style={{ width: textSizes[0], animationDelay: `${delay - 1500}ms` }}
          />
          <div
            className={`${styles.text} bg-gray-200 h-4 rounded-full`}
            style={{ width: textSizes[1], animationDelay: `${delay - 1000}ms` }}
          />
        </div>
      </div>
    );
  }
}
